import React , {useState, useEffect, useRef}from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';




function Perfil(props) {
const queryParams = new URLSearchParams(window.location.search)


const [menus, setMenus] = useState([]);
const [items, setItems] = useState([]);
const [nombrePerfil, setNombrePerfil] = useState('');
const [perfilId, setPerfilId] = useState();
const [mensaje, setMensaje] = useState('');
const inputNombrePerfil = useRef(null);
useEffect(()=>{
    const token = localStorage.getItem("token");
    axios.defaults.headers.common["token"] = token;
    //console.log(props.match.params)
    setPerfilId(queryParams.get("id"));
},[]);

useEffect(()=>{
    getDatos();
},[perfilId]);

async function getDatos(){

    let url ="/configuracion/accesos/?perfilId=" + perfilId
    await axios.get(config.api_url + url).then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
            setMenus(resp.data.menus);
            setItems(resp.data.items);
            setNombrePerfil(resp.data.perfilNombre);
        }
     }).catch(error=>{
       toast.error("Se ha generado un error al traer los datos!");
    })  
}

async function Guardar(){

    if (nombrePerfil===""){
        setMensaje("Nombre de perfil requerido!")
        inputNombrePerfil.current.focus();
    }
    
    let url = "/configuracion/perfil/"
    console.log(menus)
    let parametros ={'nombrePerfil': nombrePerfil, 'accesos':menus, 'perfilId': perfilId}
    await axios.post(config.api_url + url, parametros).then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
            toast.success(resp.data.mensaje);
        }else{
            toast.error(resp.data.mensaje)
        }
     }).catch(error=>{
       toast.error("Se ha generado un error al traer los datos!");
    })
}

function CheckAcceso(id){
    id = id.split("/")
    let menuId = id[0];
    let itemId = id[1];
    console.log(menuId);
    console.log(itemId)
    let menus_ ={... menus}; 
    if(menus_[menuId]["items"][itemId]["check"] === 1) {
        menus_[menuId]["items"][itemId]["check"] = 0
    }else{
        menus_[menuId]["items"][itemId]["check"] = 1;
    }
    setItems(menus_);
}
    return (       
        <div className="container">
            <div className='card'>
                <ToastContainer/>
                <div className='card-header'>
                    <div className="d-flex justify-content-start">
                        <a href='/configuracion/perfiles'><i class="bi bi-arrow-left-short"></i> Perfiles </a>   
                    </div>
                    <div className='row'>
                        <div className="col-md-12  d-flex justify-content-center">
                            <h2>Configurador de Perfiles y Accesos</h2>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-10 d-flex justify-content-start'>
                        <label className='etiquetaForm'>*Nombre Perfil</label>
                    </div>    
                </div>
                <div className='row  d-flex justify-content-start'>
                    <div className='col-md-10'>
                        <input type='text' className='form-control' value={nombrePerfil} ref ={inputNombrePerfil} onChange={(ev)=>setNombrePerfil(ev.target.value)}></input>
                    </div>    
                </div>
                <div className='card-body'>
                    <div className='row  d-flex justify-content-center'>
                        <div className='col-8 col-md-3'>
                            {mensaje !==""?
                            <div class="alert alert-danger" role="alert">
                            {mensaje}
                            </div>:''}
                        </div>    
                    </div>
                    <br></br>
                    {menus.map(menu =>
                    <div>
                        <div className='row'>
                            <div className='col-12 d-flex justify-content-center'>
                                <h5 >{menu.nombre}</h5>
                            </div>
                        </div>   
                        <br></br>
                        {menu.items.map((acceso, index)=>
                            <div className='row d-flex justify-content-center' style={{paddingLeft:"2%", paddingRight:"2%"}}>
                                <div className='col-5'>
                                
                                    
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" checked={acceso.check} onChange={(ev)=>CheckAcceso(ev.target.name)} name={menu.indice+ "/"+ acceso.indice}/>
                                            <label class="form-check-label" for="flexCheckDefault">
                                                <i class={acceso.icono}></i>   {acceso.nombre}
                                            </label>
                                        </div>  
                                            
                                                        
                                </div>
                                
                        </div> )}  
                            <br/>
                    </div>
                    )}
                    {/*etiqueta privilegios*/}
                    <div className='row filaFormEtiqueta'>
                        <div className='col-md-10 d-flex justify-content-start'>
                            <label className='etiquetaForm'><i className="bi bi-lock"></i> Privilegios:</label>
                        </div>
                    </div> 
                 
            
                    <div>
                        <input type='button' className='btn btn-primary' onClick={Guardar} value="Guardar"/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Perfil;